import { useEffect, useRef, useState } from "react";

export function useTopExited() : [React.RefObject<HTMLElement | null>, boolean] {
  const elementRef = useRef(null);
  const [hasExitedTop, setHasExitedTop] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // entry.boundingClientRect.top < 0 confirms it exited past the top, 
        // rather than exiting through the bottom of the screen.
        const isPastTop = entry.boundingClientRect.top < 0;
        setHasExitedTop(isPastTop);
      },
      {
        // Collapses the detection zone to just the top edge of the viewport
        rootMargin: "0px 0px -100% 0px", 
        threshold: 0,
      }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [elementRef, hasExitedTop];
}